<template>
  <g class="status-labels" transform="translate(45, 40)">
    <rect
      class="status-label-bg"
      :class="{ active: active === 'OFF' }"
      x="-36"
      y="19"
      width="44"
      height="22"
      rx="10"
      ry="10"
    ></rect>
    <rect
      class="status-label-bg"
      :class="{ active: active === 'SB' }"
      x="-28"
      y="59"
      width="36"
      height="22"
      rx="10"
      ry="10"
    ></rect>
    <rect
      class="status-label-bg"
      :class="{ active: active === 'D' }"
      x="-20"
      y="99"
      width="28"
      height="22"
      rx="10"
      ry="10"
    ></rect>
    <rect
      class="status-label-bg"
      :class="{ active: active === 'ON' }"
      x="-30"
      y="139"
      width="38"
      height="22"
      rx="10"
      ry="10"
    ></rect>
    <text
      class="status-label"
      :class="{ active: active === 'OFF' }"
      transform="translate(0, 30)"
      text-anchor="end"
      dy="0.35em"
      >OFF</text
    >
    <text
      class="status-label"
      :class="{ active: active === 'SB' }"
      transform="translate(0, 70)"
      text-anchor="end"
      dy="0.35em"
      >SB</text
    >
    <text
      class="status-label"
      :class="{ active: active === 'D' }"
      transform="translate(0, 110)"
      text-anchor="end"
      dy="0.35em"
      >D</text
    >
    <text
      class="status-label"
      :class="{ active: active === 'ON' }"
      transform="translate(0, 150)"
      text-anchor="end"
      dy="0.35em"
      >ON</text
    >
  </g>
</template>
<script>
export default {
  props: ["active"],
  mounted() {
    // console.log(this.active, 'sdklgjdsfohng');
  },
};
</script>